import type { CSSProperties, ReactNode } from 'react';
import { cn } from '../../lib/cn';

export type BadgeTone = 'muted' | 'outline' | 'danger';

const TONE_CLASSES: Record<BadgeTone, string> = {
  muted: 'bg-muted text-muted-foreground',
  outline: 'border border-border text-muted-foreground',
  danger: 'bg-destructive/10 text-destructive',
};

export interface BadgeProps {
  children: ReactNode;
  tone?: BadgeTone;
  className?: string;
  style?: CSSProperties;
}

/** A small label: inactive status, role, unit. Colour stays muted unless a state must catch the eye (plan §2.2). */
export const Badge = ({ children, tone = 'muted', className, style }: BadgeProps) => (
  <span
    className={cn(
      'inline-flex items-center whitespace-nowrap rounded px-1.5 py-0.5 text-[11px] font-medium leading-none',
      TONE_CLASSES[tone],
      className,
    )}
    style={style}
  >
    {children}
  </span>
);
